import seattle from './seattle';
import austin from './austin';
import portland from './portland';

const REGISTRY = {
  Seattle: seattle,
  Austin: austin,
  Portland: portland,
};

/**
 * Returns the logo slots for a given city. The shape is:
 *   {
 *     common: Logo[],
 *     residential?: Logo[],
 *     breweries?: Logo[],
 *     community?: Logo[],
 *     premiumPromo?: Logo[],
 *   }
 * where each Logo is { src: string, alt: string }.
 *
 * Unknown cities default to Seattle. This matches the legacy LogoList
 * fallback to DEFAULT_LOGOS so dev environments without a `city_name`
 * in ConfigContext do not crash. Static imports keep SSR synchronous.
 */
export function getCityLogos(cityName) {
  return REGISTRY[cityName] || seattle;
}

export default REGISTRY;
